module.exports = __webpack_public_path__ + "img/logo_white.3059b88b.png";